// Imports

// Class
import {System} from '../../shared-components/System';
import {Attachment} from '../../shared-components/models/attachment.model';

export class Announcement {

    // Properties
    id: number;
    AnnouncementAttachments: Attachment[];
    AnnouncementType: string;
    Course: string;
    Description: string;
    EndDate = new Date();
    Id: number;
    IsNewAnnouncement: boolean;
    IsValidForParents: boolean;
    IsValidForStudents: boolean;
    RevisedDate = new Date();
    SchoolName: string;
    ShowDaily: boolean;
    StartDate = new Date();
    StudentBirthDate = new Date();
    StudentName: string;
    Teacher: string;
    Title: string;

    // Methods
	getRevisedDate(): Date {
		return this.RevisedDate && this.RevisedDate.toString() != System.junkDateString && this.RevisedDate.toString() != 'Invalid Date' ? this.RevisedDate : null;
	}
}
